import { render, staticRenderFns } from "./ImportFailTable.vue?vue&type=template&id=7644afd8&scoped=true&"
import script from "./ImportFailTable.vue?vue&type=script&lang=js&"
export * from "./ImportFailTable.vue?vue&type=script&lang=js&"
import style0 from "./ImportFailTable.vue?vue&type=style&index=0&id=7644afd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644afd8",
  null
  
)

export default component.exports